/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import {completeCopyModal} from '../common/util/complete-copy-modal';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import {nextCopyTitle} from '../../components/util/next-copy-title';
import {Uuid} from '../../components/util/uuid';
import {ReportTemplateApiService} from './report-template-api.service';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';

export interface ReportTemplateCopyResult {
  model: any;
  destination: boolean;
}

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-report-template-copy-modal',
  template: `
    <form class="form-horizontal" (ngSubmit)="copy()">
      <div class="modal-header dialogAddStuff">
        <button type="button" class="close" (click)="dismiss()">&times;</button>
        <h4 class="modal-title">
          <span>{{ 'label.copy.reportTemplate' | ogTranslate }}</span>
          <small>{{ originalName }}</small>
        </h4>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label class="col-md-3 control-label">{{ 'label.name' | ogTranslate }}</label>
          <div class="col-md-9">
            <input type="text" class="form-control" name="reportTemplate.name" [(ngModel)]="name" required>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-3 control-label">{{ 'label.description' | ogTranslate }}</label>
          <div class="col-md-9">
            <input type="text" class="form-control" name="reportTemplate.description" [(ngModel)]="description">
          </div>
        </div>
        <div class="checkbox text-right">
          <label class="checkbox">
            <input type="checkbox" [(ngModel)]="destination" name="reportTemplate.destination">
            <span class="small">Go to new report template after copy</span>
          </label>
        </div>
      </div>
      <div class="modal-footer">
        <a class="btn btn-link btn-xs" (click)="dismiss()">{{ 'button.cancel' | ogTranslate }}</a>
        <button type="submit" class="btn btn-default">{{ 'label.copy' | ogTranslate }}</button>
      </div>
    </form>
  `
})
export class ReportTemplateCopyModalComponent implements OnInit {
  model: any;

  readonly onCopied = new Subject<ReportTemplateCopyResult>();

  originalName = '';
  name = '';
  description = '';
  destination = true;

  constructor(
    public bsModalRef: BsModalRef,
    private readonly reportTemplateApi: ReportTemplateApiService
  ) {
  }

  ngOnInit(): void {
    this.originalName = this.model?.name || '';
    this.name = nextCopyTitle(this.model?.name || '');
    this.description = this.model?.description || '';
  }

  copy(): void {
    const copy = _.cloneDeep({...this.model,
      id: Uuid.generate(),
      name: this.name,
      description: this.description
    });
    this.reportTemplateApi.save(copy).subscribe((saved) => {
      completeCopyModal(this.bsModalRef, this.onCopied, {model: saved, destination: this.destination});
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
